import React from 'react';

import DocList from 'pages/Document/DocList';

export type TabUploadProps = {
  objectid: number;
  object: string;
  entityReference?:string
  clientName?:string
};

const TabUpload = ({ object, objectid,entityReference,clientName }: TabUploadProps) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <DocList
        objectid={objectid}
        objecttype={object}
        objectreference={entityReference}
        objectname={clientName}
        hideCol
        categorie="DOC"
        tpid={Number(objectid)}
        applyFilter
      />
    </div>
  );
};

export default TabUpload;
